import React from 'react';

interface EditorialStatementProps {
  headline: string;
  subtext?: string;
  style?: React.CSSProperties;
}

export const EditorialStatement: React.FC<EditorialStatementProps> = ({ headline, subtext, style = {} }) => {
  return (
    <section 
      style={{
        padding: '96px 20px',
        textAlign: 'center',
        backgroundColor: '#121212',
        position: 'relative',
        ...style
      }}
    >
      <div className="container" style={{ maxWidth: '820px', margin: '0 auto' }}>
        <h2 
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: 'clamp(24px, 4vw, 40px)',
            fontWeight: 400,
            lineHeight: 1.25,
            letterSpacing: '-0.8px',
            color: '#FFFFFF',
            margin: '0 auto'
          }}
        >
          {headline}
        </h2>
        {subtext && (
          <p 
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontSize: '16px',
              color: '#D7D7D7',
              maxWidth: '600px',
              margin: '16px auto 0',
              lineHeight: 1.6
            }}
          >
            {subtext}
          </p>
        )}
      </div>
    </section>
  );
};

export default EditorialStatement;
